// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__2jDqt","buttons":"Main_buttons__3sqGY","time":"Main_time__255-a","message":"Main_message__2kqNT"};